module.exports = __webpack_public_path__ + "img/firearm.79cecd5d.svg";